import request from '@/utils/request'

export function fetchList(query) {
    // console.log(store.state.headerSign)
    return request({
        url: '/store/api/home/getExhibitionList',
        method: 'get',
        params: query,
        // headers: {
        //     'sign': store.state.headerSign
        // }
    })

}
export function getData(query) {
    //console.log(store.state.headerSign)
    return request({
        url: '/store/api/home/getExhibitionList',
        method: 'get',
        params: query,
        // headers: {
        //     'sign': store.state.headerSign
        // }
    })

}
export function getHot(query) {
    //console.log(store.state.headerSign)
    return request({
        url: '/store/api/home/getHot',
        method: 'get',
        params: query,
        // headers: {
        //     'sign': store.state.headerSign
        // }
    })

}
export function getMore(query) {
    //console.log(store.state.headerSign)
    return request({
        url: '/store/api/home/getHot',
        method: 'get',
        params: query,
        // headers: {
        //     'sign': store.state.headerSign
        // }
    })

}
export function getNotice(query) {
    // console.log(store.state.headerSign)
    return request({
        url: '/store/api/Message/index',
        method: 'get',
        params: query,
        // headers: {
        //     'sign': store.state.headerSign
        // }
    })

}



// WEBPACK FOOTER //
// ./src/api/homepage.js